import { Equipment, RawEquipment } from './typings';

export const serializeEquipmentForFront = (data: RawEquipment): Equipment => ({
  id: data.id,
  name: data.fields.Name,
});
